import { createStyles, IconButton, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import { mainTheme } from '../Theme';
// import htmlToDraft from 'html-to-draftjs';
// import { ContentState, EditorState } from 'draft-js';
// import { Editor } from 'react-draft-wysiwyg';
// import MUIRichTextEditor from 'mui-rte';
import { FeatureNotesPreviewDialog } from '../featureConfigurationLayout/dialogs/FeatureNotesPreviewDialog';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        popover: {
            pointerEvents: 'none',
        },
        paper: {
            padding: theme.spacing(1),
            maxWidth: '960px',
        },
        root: {
            color: mainTheme.TemplateColor.Primary,
        },
    }),
);

interface ChartInfoProps {
    className?: string;
    fontSize?: 'inherit' | 'default' | 'medium' | 'small' | 'large';
    description?: string;
}

export const ChartInfo: React.FC<ChartInfoProps> = (props) => {
    
    const classes = useStyles();
    
    // const [anchorEl, setAnchorEl] = React.useState<SVGSVGElement | null>(null);

    const [isNotesPreviewOpen, setIsNotesPreviewOpen] = React.useState(false);

    // const handlePopoverOpen = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    //     setAnchorEl(event.currentTarget);
    // };

    // const handlePopoverClose = () => {
    //     setAnchorEl(null);
    // };

    // const open = Boolean(anchorEl);

    // const editorComponent = () => {

    //     let description = `
    //         <p>No information was created on this chart</p>
    //         <p>Go to <strong>Configuration Page </strong>to create one<strong>:</strong></p>
    //         <ul>
    //             <li><em>Configuration &gt; Firm Dashboard</em></li>
    //             <li><em>Configuration &gt; Fee Earner Dashboard</em></li>
    //             <li><em>Configuration &gt; Enquiry Dashboard</em></li>
    //             <li><em>Configuration &gt; Task Dashboard</em></li>
    //             <li><em>Configuration &gt; Client Dashboard</em></li>
    //         </ul>
    //     `;

    //     if (props.description) {
    //         description = props.description;
    //     }

    //     if (description.indexOf('blocks":') !== -1) {
    //         return <MUIRichTextEditor value={description} readOnly={true} toolbar={false} />;
    //     } else {
    //         const contentBlock = htmlToDraft(description);

    //         const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);

    //         const editorState = EditorState.createWithContent(contentState);

    //         return (
    //             <>
    //                 <Editor editorState={editorState} readOnly={true} toolbarHidden={true} />
    //             </>
    //         );
    //     }
    // };

    const onPreviewNotes = () => {
        setIsNotesPreviewOpen(!isNotesPreviewOpen);
    };

    if (!props.description) {
        return null;
    }
    
    return (
        <>
            {isNotesPreviewOpen ? (
                <FeatureNotesPreviewDialog 
                    open={isNotesPreviewOpen}
                    description={props.description}
                    onClose={onPreviewNotes}
                />
            ) : undefined}
            {props.description ? (
                <IconButton 
                    aria-label="preview" 
                    size="small" 
                    className={`${classes.root} ${props.className}`}
                    onClick={onPreviewNotes}
                >
                    <InfoIcon />
                </IconButton>
            ) : undefined}
            {/* <InfoIcon
                className={`${classes.root} ${props.className}`}
                fontSize={props.fontSize}
                onClick={onPreviewNotes}
                // onMouseEnter={handlePopoverOpen}
                // onMouseLeave={handlePopoverClose}
            /> */}
            {/* <Popover
                id="mouse-over-popover"
                className={classes.popover}
                classes={{
                    paper: classes.paper,
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus={true}
            >
                {editorComponent()}
            </Popover> */}
        </>
    );
};
